<div class="common-pagination-buttons" [ngClass]="containerClasses">
  <div class="common-pagination-buttons__meta" *ngIf="showTotalCountResolved || showPageSizeSelector">
    <div class="common-pagination-buttons__total" *ngIf="showTotalCountResolved">
      <span class="common-pagination-buttons__total-label s1_500">{{ totalCountLabel }}</span>
      <span class="common-pagination-buttons__total-value s1_500">{{ length }}</span>
    </div>
  </div>

  <mat-paginator
    *ngIf="!showPageNumbers"
    [length]="length"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [hidePageSize]="true"
    [showFirstLastButtons]="showFirstLastButtons"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel || null"
    (page)="onPage($event)"
  ></mat-paginator>

  <nav class="common-pagination-buttons__pages" *ngIf="showPageNumbers" [attr.aria-label]="ariaLabel || null">
    <button
      type="button"
      class="common-pagination-buttons__nav"
      [disabled]="disabled || isFirstPage"
      [attr.aria-label]="previousPageLabel"
      (click)="onPrevPage()"
    >
      <span class="material-symbols-rounded" aria-hidden="true">chevron_left</span>
    </button>

    <ng-container *ngFor="let item of pageItems; trackBy: trackByPageItem">
      <span *ngIf="item === null" class="common-pagination-buttons__ellipsis" aria-hidden="true">…</span>
      <button
        *ngIf="item !== null"
        type="button"
        class="common-pagination-buttons__page"
        [class.common-pagination-buttons__page--current]="isCurrentPage(item)"
        [attr.aria-current]="isCurrentPage(item) ? 'page' : null"
        [disabled]="disabled"
        (click)="goToPage(item)"
      >
        {{ item }}
      </button>
    </ng-container>

    <button
      type="button"
      class="common-pagination-buttons__nav"
      [disabled]="disabled || isLastPage"
      [attr.aria-label]="nextPageLabel"
      (click)="onNextPage()"
    >
      <span class="material-symbols-rounded" aria-hidden="true">chevron_right</span>
    </button>

    <span class="common-pagination-buttons__page-of s2_500" *ngIf="pageOfLabel">{{ pageOfLabel }}</span>
  </nav>

  <div class="common-pagination-buttons__per-page" *ngIf="showPageSizeSelector">
    <span class="common-pagination-buttons__per-page-label s2_500">{{ pageSizeLabel }}</span>
    <mat-form-field class="common-pagination-buttons__per-page-field" appearance="outline">
      <mat-select
        class="common-pagination-buttons__per-page-select"
        [value]="pageSize"
        (selectionChange)="onPageSizeSelect($event.value)"
      >
        <mat-option *ngFor="let opt of pageSizeOptions" [value]="opt">{{ opt }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>